import React from "react";
import { TimePicker, Tooltip } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// 加载dayjs插件
dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * UTC时间范围选择器组件
 * 强制以UTC时区显示和处理时间范围
 * 无论用户当前系统时区如何，输入和输出都是UTC时区
 */
const UTCTimeRangePicker = ({ value, onChange, format = "HH:mm", style, placeholder, disabled, ...restProps }) => {
    // 将value转换为UTC dayjs对象数组
    const utcValue = value
        ? value.map((time) => {
              if (!time) return null;

              return typeof time === "string" && !time.includes("T") && !time.includes(" ") ? dayjs.utc(`2000-01-01T${time}`) : dayjs.utc(time);
          })
        : [];

    // 处理时间范围变更
    const handleChange = (times, timeStrings) => {
        // 如果times为null，直接传递给外部onChange
        if (!times || times.length === 0) {
            onChange && onChange(null, []);
            return;
        }

        // 强制将选择的时间解释为UTC时区
        const utcTimes = times.map((time) => {
            if (!time) return null;

            // 提取时分秒
            const hour = time.hour();
            const minute = time.minute();
            const second = time.second();

            // 使用这些值创建真正的UTC时间（不带时区偏移）
            return dayjs.utc().hour(hour).minute(minute).second(second).millisecond(0);
        });

        // 生成时间字符串
        const utcTimeStrings = utcTimes.map((time) => (time ? time.format(format) : ""));

        // 调用外部onChange，传递UTC时间
        onChange && onChange(utcTimes, utcTimeStrings);
    };

    return (
        <Tooltip title="此时间范围以UTC时区解释">
            <TimePicker.RangePicker
                value={utcValue.length === 2 ? utcValue : undefined}
                onChange={handleChange}
                format={format}
                style={{ width: "100%", ...style }}
                placeholder={placeholder ? placeholder : ["开始时间(UTC)", "结束时间(UTC)"]}
                disabled={disabled}
                suffixIcon={<GlobalOutlined style={{ color: "#1890ff" }} />}
                minuteStep={5}
                needConfirm={false}
                allowClear
                showNow={false}
                order={false}
                {...restProps}
            />
        </Tooltip>
    );
};

export default UTCTimeRangePicker;
